import { loadTenant } from '@sophocles/features/tenant/api';
import store from '@sophocles/store/redux-store';

export const initializeTenant = () => {
  return store.dispatch(loadTenant()).then(() => {
    return true;
  });
};
